import { render, staticRenderFns } from "./ContactsFragmentDesktopBirthdayList.vue?vue&type=template&id=4958a2e1&scoped=true&"
import script from "./ContactsFragmentDesktopBirthdayList.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentDesktopBirthdayList.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFragmentDesktopBirthdayList.vue?vue&type=style&index=0&id=4958a2e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958a2e1",
  null
  
)

export default component.exports